import { CALL_API } from '../../api';
import * as ActionTypes from './product.actionTypes';
import schema from '../../api/schema';

const readProducts = (returnPrivates) => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_PRODUCTS_REQUEST,
      ActionTypes.READ_PRODUCTS_SUCCESS,
      ActionTypes.READ_PRODUCTS_FAILURE,
    ],
    endpoint: 'api/product' + (returnPrivates ? '?private=true' : '?private=false'),
    schema: schema.productsSchema,
    authorization: true,
  }
});

export const getProducts = (returnPrivates) => (dispatch, getState) => {
  return dispatch(readProducts(returnPrivates));
};

const readProduct = (id) => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_PRODUCT_REQUEST,
      ActionTypes.READ_PRODUCT_SUCCESS,
      ActionTypes.READ_PRODUCT_FAILURE,
    ],
    endpoint: `api/product/${id}`,
    schema: schema.productSchema,
    authorization: true,
  },
  payload: {
    id
  }
});

export const getProduct = (id) => (dispatch, getState) => {
  return dispatch(readProduct(id));
};

const doCreateProduct = (data) => ({
  [CALL_API]: {
    types: [
      ActionTypes.CREATE_PRODUCT_REQUEST,
      ActionTypes.CREATE_PRODUCT_SUCCESS,
      ActionTypes.CREATE_PRODUCT_FAILURE,
    ],
    endpoint: 'api/product/',
    schema: schema.productSchema,
    authorization: true,
    requestInit: {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(data)
    },
  }
});

export const createProduct = (data) => (dispatch, getState) => {
  return dispatch(doCreateProduct(data));
};

const doUpdateProductScores = (data) => ({
  [CALL_API]: {
    types: [
      ActionTypes.UPDATE_PRODUCT_SCORES_REQUEST,
      ActionTypes.UPDATE_PRODUCT_SCORES_SUCCESS,
      ActionTypes.UPDATE_PRODUCT_SCORES_FAILURE,
    ],
    endpoint: `api/product/scores`,
    schema: schema.productsSchema,
    authorization: true,
    requestInit: {
      method: 'PUT',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(data)
    },
  },
});

export const updateProductScores = (data) => (dispatch, getState) => {
  return dispatch(doUpdateProductScores(data));
};

const doUpdateProduct = (data) => ({
  [CALL_API]: {
    types: [
      ActionTypes.UPDATE_PRODUCT_REQUEST,
      ActionTypes.UPDATE_PRODUCT_SUCCESS,
      ActionTypes.UPDATE_PRODUCT_FAILURE,
    ],
    endpoint: `api/product/${data._id}`,
    schema: schema.productSchema,
    authorization: true,
    requestInit: {
      method: 'PUT',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(data)
    },
  },
  payload: {
    id: data._id
  }
});

export const updateProduct = (data) => (dispatch, getState) => {
  return dispatch(doUpdateProduct(data));
};

const doDeleteProduct = (id) => ({
  [CALL_API]: {
    types: [
      ActionTypes.DELETE_PRODUCT_REQUEST,
      ActionTypes.DELETE_PRODUCT_SUCCESS,
      ActionTypes.DELETE_PRODUCT_FAILURE,
    ],
    endpoint: `api/product/${id}`,
    schema: schema.productSchema,
    authorization: true,
    requestInit: {
      method: 'DELETE',
    },
  },
  payload: {
    id
  }
});

export const deleteProduct = (id) => (dispatch, getState) => {
  return dispatch(doDeleteProduct(id));
};


// WEBPACK FOOTER //
// ./src/modules/product/product.actions.js